import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconLinkSmall({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M3.5 3.5a2.5 2.5 0 0 0 0 5H5a.5.5 0 0 0 0-1H3.5a1.5 1.5 0 1 1 0-3H5a.5.5 0 0 0 0-1H3.5zm5 0a2.5 2.5 0 0 1 0 5H7a.5.5 0 0 1 0-1h1.5a1.5 1.5 0 1 0 0-3H7a.5.5 0 0 1 0-1h1.5zm-4 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z"/>
        </svg>
    );
}

export default IconLinkSmall;
